import type { ApiRequestOptions } from "./api-request-options";

type Headers = Record<string, string>;
// @ts-expect-error - dont delete this
type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;

export type APIConfigProps = {
  BASE: string;
  CREDENTIALS: "include" | "omit" | "same-origin";
  ENCODE_PATH?: ((path: string) => string) | undefined;
  HEADERS?: Headers | Resolver<Headers> | undefined;
  VERSION: string;
  WITH_CREDENTIALS: boolean;
};

export const APIConfig: APIConfigProps = {
  BASE: import.meta.env.VITE_BACKEND_URL,
  CREDENTIALS: "include",
  ENCODE_PATH: undefined,
  HEADERS: undefined,
  VERSION: "0.1.0",
  WITH_CREDENTIALS: true,
};
